import type { ManualResourceInput, RegistryResource } from './registry.types.js';

export const REGISTRY_IMPORT_MAX_BYTES = 262144;
export const REGISTRY_IMPORT_MAX_ROWS = 500;
export const REGISTRY_IMPORT_STATUSES = [
  'new',
  'existing',
  'duplicate',
  'conflict',
  'archived',
  'invalid',
] as const;
export type RegistryImportStatus = (typeof REGISTRY_IMPORT_STATUSES)[number];
export interface RegistryImportInput {
  text: string;
  format: 'text' | 'csv';
  ownership: ManualResourceInput['ownership'];
}
export type RegistryImportMatch = Pick<
  RegistryResource,
  'key' | 'source' | 'sourceId' | 'title' | 'address' | 'ownership' | 'revision'
>;
export interface RegistryImportRow {
  line: number;
  input: string;
  status: RegistryImportStatus;
  message: string;
  resource?: ManualResourceInput;
  platform?: RegistryResource['platform'];
  matches: RegistryImportMatch[];
  matchCount: number;
}
export interface RegistryImportPreview {
  rows: RegistryImportRow[];
  counts: Record<RegistryImportStatus, number>;
  fingerprint: string;
}
export interface RegistryImportResult {
  added: number;
  skipped: number;
}
